import React, { useState, useEffect } from 'react'
import { Input } from '../../components/ui/input'

export const InputOTP = ({ length = 6, onChange }: { length?: number; onChange?: (value: string) => void }) => {
  const [otp, setOtp] = useState(Array(length).fill(''))

  // Auto-focus the first input field when component mounts
  useEffect(() => {
    const firstInput = document.getElementById('otp-0')
    if (firstInput) {
      firstInput.focus()
    }
  }, [])

  const handleChange = (value: string, index: number) => {
    if (value.length > 1) return

    const newOtp = [...otp]
    newOtp[index] = value
    setOtp(newOtp)
    onChange?.(newOtp.join(''))

    if (value && index < length - 1) {
      const nextInput = document.getElementById(`otp-${index + 1}`)
      nextInput?.focus()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace' && !otp[index]) {
      const prevInput = document.getElementById(`otp-${index - 1}`)
      prevInput?.focus()
    }
  }

  return (
    <div className="flex space-x-2">
      {otp.map((_, index) => (
        <Input
          key={index}
          id={`otp-${index}`}
          type="text"
          value={otp[index]}
          maxLength={1}
          className="w-12 h-12 rounded-full text-center text-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-muted"
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  )
}

export default InputOTP
